import type { HistorySection } from "./types";

export const historySections: HistorySection[] = [
  {
    year: "2025",
    title:
      "VII МЕЖДУНАРОДНАЯ НАУЧНО-ПРАКТИЧЕСКАЯ КОНФЕРЕНЦИЯ «SOCIAL SCIENCE»: (Общественные науки)",
  },
  {
    year: "2024",
    title:
      "VI МЕЖДУНАРОДНАЯ НАУЧНО-ПРАКТИЧЕСКАЯ КОНФЕРЕНЦИЯ «SOCIAL SCIENCE»: (Общественные науки)",
  },
  {
    year: "2023",
    title:
      "V МЕЖДУНАРОДНАЯ НАУЧНО-ПРАКТИЧЕСКАЯ КОНФЕРЕНЦИЯ «SOCIAL SCIENCE» (Общественные науки) «СТРАТЕГИИ РАЗВИТИЯ ОБЩЕСТВА И ЭКОНОМИКИ В НОВОЙ РЕАЛЬНОСТИ»",
  },
  {
    year: "2022",
    title:
      "IV МЕЖДУНАРОДНАЯ НАУЧНО-ПРАКТИЧЕСКАЯ КОНФЕРЕНЦИЯ «SOCIAL SCIENCE» (Общественные науки) «СТРАТЕГИИ РАЗВИТИЯ ОБЩЕСТВА И ЭКОНОМИКИ В НОВОЙ РЕАЛЬНОСТИ»",
  },
  {
    year: "2021",
    title:
      "III МЕЖДУНАРОДНАЯ НАУЧНО-ПРАКТИЧЕСКАЯ КОНФЕРЕНЦИЯ «SOCIAL SCIENCE» (Общественные науки) «СОВРЕМЕННЫЕ СТРАТЕГИИ УСТОЙЧИВОГО РАЗВИТИЯ ГОСУДАРСТВА И ОБЩЕСТВА В КОНТЕКСТЕ ГЛОБАЛЬНЫХ ВЫЗОВОВ»",
  },
  {
    year: "2020",
    title:
      "II МЕЖДУНАРОДНАЯ НАУЧНО-ПРАКТИЧЕСКАЯ КОНФЕРЕНЦИЯ «SOCIAL SCIENCE» (Общественные науки) «СОЦИАЛЬНЫЕ ИНСТИТУТЫ В ЦИФРОВОЙ СРЕДЕ (SIDE)»",
  },
  {
    year: "2019",
    title:
      "I МЕЖДУНАРОДНАЯ НАУЧНО-ПРАКТИЧЕСКАЯ КОНФЕРЕНЦИЯ «SOCIAL SCIENCE» (Общественные науки)",
  },
];
